import { useEffect, useState } from "react";
import api, { ACTIVITY_KEY, lastActivity } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

const IDLE_MS = 30 * 60 * 1000;
const WARN_MS = 60 * 1000;
const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];

const markActive = () => {
  if (Date.now() - lastActivity() > 10000) localStorage.setItem(ACTIVITY_KEY, String(Date.now()));
};

export const IdleWatcher = ({ onExpire }) => {
  const [left, setLeft] = useState(null);

  useEffect(() => {
    localStorage.setItem(ACTIVITY_KEY, String(Date.now()));
    EVENTS.forEach((e) => window.addEventListener(e, markActive, { passive: true }));
    let lastPing = Date.now();
    const tick = setInterval(() => {
      const idle = Date.now() - lastActivity();
      if (idle >= IDLE_MS) { onExpire(); return; }
      setLeft(idle >= IDLE_MS - WARN_MS ? Math.ceil((IDLE_MS - idle) / 1000) : null);
      if (idle < 5 * 60 * 1000 && Date.now() - lastPing > 4 * 60 * 1000) {
        lastPing = Date.now();
        api.post("/auth/heartbeat").catch(() => {});
      }
    }, 1000);
    return () => {
      clearInterval(tick);
      EVENTS.forEach((e) => window.removeEventListener(e, markActive));
    };
  }, [onExpire]);

  const stay = () => {
    localStorage.setItem(ACTIVITY_KEY, String(Date.now()));
    setLeft(null);
    api.post("/auth/heartbeat").catch(() => {});
  };

  return (
    <Dialog open={left !== null} onOpenChange={(o) => { if (!o) stay(); }}>
      <DialogContent className="sm:max-w-sm" data-testid="idle-warning-dialog">
        <DialogHeader>
          <DialogTitle>Are you still there?</DialogTitle>
          <DialogDescription>
            For your security you will be signed out in <span className="font-semibold text-foreground" data-testid="idle-countdown">{left}s</span> due to inactivity.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onExpire} data-testid="idle-signout-btn">Sign out</Button>
          <Button onClick={stay} className="bg-emerald-500 hover:bg-emerald-600 text-[#062217]" data-testid="idle-stay-btn">Stay signed in</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
